export default __webpack_public_path__ + "static/media/download-dark.8383c5b9.svg";